module.exports = __webpack_public_path__ + "media/application/images/icons/location-96c4acfa12c9e596e20b320f44261af5.svg";